// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"379":"mainBox","414":"moduleContent","552":"rules","962":"home"}[chunkId] || chunkId) + "." + {"349":"eaf91275","379":"1bc27349","414":"8d1ea108","552":"96362bcf","596":"971071bf","840":"2a945a5b","929":"bebce1e9","962":"452186c1"}[chunkId] + ".css";
};